import React from 'react';

import Votes from './Votes';
import Amount from './Amount';
import Rating from './Rating';
import Classification from './Classification';
import Modal from './Modal';

function findDetractor(list) {
    let value = 0;
    for(let i = 0; i < list.length; i++) {
        if (i >= 0 && i < 7) {
            value += parseInt(list[i]);
        }
    }
    return value;
}

function findNeutral(list) {
    let value = 0;
    for(let i = 0; i < list.length; i++) {
        if (i > 6 && i < 9) {
            value += parseInt(list[i]);
        }
    }
    return value;
}

function findPromoter(list) {
    let value = 0;
    for(let i = 0; i < list.length; i++) {
        if (i > 8 && i <= 10) {
            value += parseInt(list[i]);
        }
    }
    return value;
}

function prctgConverter(value, total) {
    let prctg = value * 100 / total;
    if (Number.isNaN(prctg)) {
        return 0;
    }
    return prctg.toFixed(2);
}

export default class Calculator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        };

        this.handleChange = this.handleChange.bind(this);
        this.openForm = this.openForm.bind(this);
        this.closeForm = this.closeForm.bind(this);
    }

    handleChange(e) {
        let v = parseInt(e.target.value);
        if (Number.isNaN(v)) {
            v = 0;
        }
        let i = e.target.id;
        let newlist = this.state.list;
        newlist[i] = v;

        this.setState({ list: newlist });
        console.log(this.state.list);
    }

    openForm() {
        let form = document.getElementById('hi-form-modal');
        form.style.display = 'block';
    }

    closeForm() {
        let form = document.getElementById('hi-form-modal');
        form.style.display = 'none';
        // let nps = document.getElementById('hi-score');
        // nps.style.display = 'block';
    }

    render() {
        const numbers = this.state.list;

        const votes = numbers.map((number, i) => (
            <Votes
                key={i}
                index={i}
                change={this.handleChange} />
        ));

        const list = this.state.list;
        const detractor = findDetractor(list);
        const neutral = findNeutral(list);
        const promoter = findPromoter(list);

        const amount = 
            <Amount
                detractor={detractor}
                neutral={neutral}
                promoter={promoter} />;

        const total = detractor + neutral + promoter;
        const rating =
            <Rating
                detrator={prctgConverter(detractor, total)}
                neutro={prctgConverter(neutral, total)}
                promotor={prctgConverter(promoter, total)} />;
        
        const score = prctgConverter(promoter, total) - prctgConverter(detractor, total);
        
        const classification = 
            <Classification
                prctg={score} />;

        const modal =
            <Modal close={this.closeForm} />

        return(
            <div>
                <div className="hi-content-box">
                    <span className="hi-index-box first" id="hi-nps-start">1</span>
                    <h3>Pergunte aos seus clientes:</h3>
                    <p>
                        Em uma escala de 0 a 10, quanto você recomendaria nossa 
                        empresa para um amigo ou familiar?
                    </p>
                </div>
                <div className="hi-content-box">
                    <h3>Insira o número de respostas obtidas para cada pontuação e saiba seu NPS</h3>
                    <span className="hi-detractor-label large">Detrator</span>
                    <span className="hi-neutral-label large">Neutro</span>
                    <span className="hi-promoter-label large">Promotor</span>
                    <br />
                    <span className="hi-index-box second">2</span>
                    {votes}
                </div>
                <div className="hi-content-box">
                    <h3>Classificação dos seus clientes</h3>
                    <span className="hi-index-box third">3</span>
                    <div className="hi-content-side">
                            {amount}
                            {rating}
                    </div>
                </div>
                <div className="hi-content-box">
                    <span className="hi-index-box fourth">4</span>
                    <h3>Veja seu Net Promoter Score:</h3>
                        <button className="hi-regular-button center" onClick={this.openForm}>Calcular NPS</button>
                </div>
                {classification}
                {modal}
            </div>
        );
    }
}